'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('./svg-icon-501cae97.js');
var close = require('./close-40bc5458.js');
var exclamationMark = require('./exclamation-mark-02f43bf2.js');
var pictureAdd = require('./picture-add-541a4480.js');
require('./pill-80fa7aa7.js');
require('./form-field-568b9a9c.js');
require('./asterisk-436ee6b3.js');
require('./field-label-4ed9b7f8.js');
var _commonjsHelpers = require('./_commonjsHelpers-1b94f6bc.js');
require('./field-hint-cc714695.js');
require('./messages-f8f39369.js');
require('./loader-f28c8bde.js');
require('./select-6c9d108c.js');
require('./select-item-7fd13c43.js');
require('./select-title-65885e9f.js');
var button = require('./button-d7f037ee.js');
require('./calendar-date.styles-9072cd1e.js');
require('./styles-20009c57.js');
require('./index.esm-c41adfff.js');
var index$4 = require('./index-c25ba35c.js');
require('./fa-icon-d6ca067a.js');
require('./field.styles-a36bbd7b.js');
require('./styles-424066e0.js');
require('./overlay-878554b6.js');
require('./paper-e6cfe656.js');
require('./style-d0a65e48.js');
require('./styles-558f9987.js');
require('./native-select.styles-3602a739.js');
require('./select-wrapper.styles-0104a777.js');
require('./device.context-f96381a3.js');
require('./mobile-detect-2421ba00.js');
require('./styles-38df6401.js');
require('./styles-f287cb5d.js');
require('./status-indicator-f5477803.js');
require('./styles-6fa8f6cf.js');
require('./text-break-b3fca248.js');
require('./tooltip-8d9d80ea.js');

var dist = _commonjsHelpers.createCommonjsModule(function (module) {
module.exports=function(t){function n(e){if(r[e])return r[e].exports;var o=r[e]={i:e,l:!1,exports:{}};return t[e].call(o.exports,o,o.exports,n),o.l=!0,o.exports}var r={};return n.m=t,n.c=r,n.d=function(t,r,e){n.o(t,r)||Object.defineProperty(t,r,{configurable:!1,enumerable:!0,get:e});},n.n=function(t){var r=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(r,"a",r),r},n.o=function(t,n){return Object.prototype.hasOwnProperty.call(t,n)},n.p="",n(n.s=13)}([function(t,n){var r=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=r);},function(t,n){t.exports=function(t){return "object"==typeof t?null!==t:"function"==typeof t};},function(t,n){var r=t.exports={version:"2.5.0"};"number"==typeof __e&&(__e=r);},function(t,n,r){t.exports=!r(4)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a});},function(t,n){t.exports=function(t){try{return !!t()}catch(t){return !0}};},function(t,n){var r={}.toString;t.exports=function(t){return r.call(t).slice(8,-1)};},function(t,n,r){var e=r(32)("wks"),o=r(9),i=r(0).Symbol,u="function"==typeof i;(t.exports=function(t){return e[t]||(e[t]=u&&i[t]||(u?i:o)("Symbol."+t))}).store=e;},function(t,n,r){var e=r(0),o=r(2),i=r(8),u=r(22),c=r(10),f=function(t,n,r){var a,s,p,l,v=t&f.F,y=t&f.G,h=t&f.S,d=t&f.P,x=t&f.B,g=y?e:h?e[n]||(e[n]={}):(e[n]||{}).prototype,m=y?o:o[n]||(o[n]={}),b=m.prototype||(m.prototype={});y&&(r=n);for(a in r)s=!v&&g&&void 0!==g[a],p=(s?g:r)[a],l=x&&s?c(p,e):d&&"function"==typeof p?c(Function.call,p):p,g&&u(g,a,p,t&f.U),m[a]!=p&&i(m,a,l),d&&b[a]!=p&&(b[a]=p);};e.core=o,f.F=1,f.G=2,f.S=4,f.P=8,f.B=16,f.W=32,f.U=64,f.R=128,t.exports=f;},function(t,n,r){var e=r(16),o=r(21);t.exports=r(3)?function(t,n,r){return e.f(t,n,o(1,r))}:function(t,n,r){return t[n]=r,t};},function(t,n){var r=0,e=Math.random();t.exports=function(t){return "Symbol(".concat(void 0===t?"":t,")_",(++r+e).toString(36))};},function(t,n,r){var e=r(24);t.exports=function(t,n,r){if(e(t),void 0===n)return t;switch(r){case 1:return function(r){return t.call(n,r)};case 2:return function(r,e){return t.call(n,r,e)};case 3:return function(r,e,o){return t.call(n,r,e,o)}}return function(){return t.apply(n,arguments)}};},function(t,n){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t};},function(t,n,r){var e=r(28),o=Math.min;t.exports=function(t){return t>0?o(e(t),9007199254740991):0};},function(t,n,r){n.__esModule=!0,n.default=function(t,n){if(t&&n){var r=Array.isArray(n)?n:n.split(","),e=t.name||"",o=t.type||"",i=o.replace(/\/.*$/,"");return r.some(function(t){var n=t.trim();return "."===n.charAt(0)?e.toLowerCase().endsWith(n.toLowerCase()):n.endsWith("/*")?i===n.replace(/\/.*$/,""):o===n})}return !0},r(14),r(34);},function(t,n,r){r(15),t.exports=r(2).Array.some;},function(t,n,r){var e=r(7),o=r(25)(3);e(e.P+e.F*!r(33)([].some,!0),"Array",{some:function(t){return o(this,t,arguments[1])}});},function(t,n,r){var e=r(17),o=r(18),i=r(20),u=Object.defineProperty;n.f=r(3)?Object.defineProperty:function(t,n,r){if(e(t),n=i(n,!0),e(r),o)try{return u(t,n,r)}catch(t){}if("get"in r||"set"in r)throw TypeError("Accessors not supported!");return "value"in r&&(t[n]=r.value),t};},function(t,n,r){var e=r(1);t.exports=function(t){if(!e(t))throw TypeError(t+" is not an object!");return t};},function(t,n,r){t.exports=!r(3)&&!r(4)(function(){return 7!=Object.defineProperty(r(19)("div"),"a",{get:function(){return 7}}).a});},function(t,n,r){var e=r(1),o=r(0).document,i=e(o)&&e(o.createElement);t.exports=function(t){return i?o.createElement(t):{}};},function(t,n,r){var e=r(1);t.exports=function(t,n){if(!e(t))return t;var r,o;if(n&&"function"==typeof(r=t.toString)&&!e(o=r.call(t)))return o;if("function"==typeof(r=t.valueOf)&&!e(o=r.call(t)))return o;if(!n&&"function"==typeof(r=t.toString)&&!e(o=r.call(t)))return o;throw TypeError("Can't convert object to primitive value")};},function(t,n){t.exports=function(t,n){return {enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}};},function(t,n,r){var e=r(0),o=r(8),i=r(23),u=r(9)("src"),c=Function.toString,f=(""+c).split("toString");r(2).inspectSource=function(t){return c.call(t)},(t.exports=function(t,n,r,c){var a="function"==typeof r;a&&(i(r,"name")||o(r,"name",n)),t[n]!==r&&(a&&(i(r,u)||o(r,u,t[n]?""+t[n]:f.join(String(n)))),t===e?t[n]=r:c?t[n]?t[n]=r:o(t,n,r):(delete t[n],o(t,n,r)));})(Function.prototype,"toString",function(){return "function"==typeof this&&this[u]||c.call(this)});},function(t,n){var r={}.hasOwnProperty;t.exports=function(t,n){return r.call(t,n)};},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t};},function(t,n,r){var e=r(10),o=r(26),i=r(27),u=r(12),c=r(29);t.exports=function(t,n){var r=1==t,f=2==t,a=3==t,s=4==t,p=6==t,l=5==t||p,v=n||c;return function(n,c,y){for(var h,d,x=i(n),g=o(x),m=e(c,y,3),b=u(g.length),_=0,w=r?v(n,b):f?v(n,0):void 0;b>_;_++)if((l||_ in g)&&(h=g[_],d=m(h,_,x),t))if(r)w[_]=d;else if(d)switch(t){case 3:return !0;case 5:return h;case 6:return _;case 2:w.push(h);}else if(s)return !1;return p?-1:a||s?s:w}};},function(t,n,r){var e=r(5);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return "String"==e(t)?t.split(""):Object(t)};},function(t,n,r){var e=r(11);t.exports=function(t){return Object(e(t))};},function(t,n){var r=Math.ceil,e=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?e:r)(t)};},function(t,n,r){var e=r(30);t.exports=function(t,n){return new(e(t))(n)};},function(t,n,r){var e=r(1),o=r(31),i=r(6)("species");t.exports=function(t){var n;return o(t)&&(n=t.constructor,"function"!=typeof n||n!==Array&&!o(n.prototype)||(n=void 0),e(n)&&null===(n=n[i])&&(n=void 0)),void 0===n?Array:n};},function(t,n,r){var e=r(5);t.exports=Array.isArray||function(t){return "Array"==e(t)};},function(t,n,r){var e=r(0),o=e["__core-js_shared__"]||(e["__core-js_shared__"]={});t.exports=function(t){return o[t]||(o[t]={})};},function(t,n,r){var e=r(4);t.exports=function(t,n){return !!t&&e(function(){n?t.call(null,function(){},1):t.call(null);})};},function(t,n,r){r(35),t.exports=r(2).String.endsWith;},function(t,n,r){var e=r(7),o=r(12),i=r(36),u="".endsWith;e(e.P+e.F*r(38)("endsWith"),"String",{endsWith:function(t){var n=i(this,t,"endsWith"),r=arguments.length>1?arguments[1]:void 0,e=o(n.length),c=void 0===r?e:Math.min(o(r),e),f=String(t);return u?u.call(n,f,c):n.slice(c-f.length,c)===f}});},function(t,n,r){var e=r(37),o=r(11);t.exports=function(t,n,r){if(e(n))throw TypeError("String#"+r+" doesn't accept regex!");return String(o(t))};},function(t,n,r){var e=r(1),o=r(5),i=r(6)("match");t.exports=function(t){var n;return e(t)&&(void 0!==(n=t[i])?!!n:"RegExp"==o(t))};},function(t,n,r){var e=r(6)("match");t.exports=function(t){var n=/./;try{"/./"[t](n);}catch(r){try{return n[e]=!1,!"/./"[t](n)}catch(t){}}return !0};}]);
});

var accepts = /*@__PURE__*/_commonjsHelpers.unwrapExports(dist);

var supportMultiple = typeof document !== 'undefined' && document && document.createElement ? 'multiple' in document.createElement('input') : true;

function getDataTransferItems(event) {
  var dataTransferItemsList = [];
  if (event.dataTransfer) {
    var dt = event.dataTransfer;

    if (dt.files && dt.files.length) {
      dataTransferItemsList = dt.files;
    } else if (dt.items && dt.items.length) {
      // During the drag even the dataTransfer.files is null
      // but Chrome implements some drag store, which is accesible via dataTransfer.items
      dataTransferItemsList = dt.items;
    }
  } else if (event.target && event.target.files) {
    dataTransferItemsList = event.target.files;
  }

  // Convert from DataTransferItemsList to the native Array
  return Array.prototype.slice.call(dataTransferItemsList);
}

// Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted
function fileAccepted(file, accept) {
  return file.type === 'application/x-moz-file' || accepts(file, accept);
}

function fileMatchSize(file, maxSize, minSize) {
  return file.size <= maxSize && file.size >= minSize;
}

function allFilesAccepted(files, accept) {
  return files.every(function (file) {
    return fileAccepted(file, accept);
  });
}

// allow the entire document to be a drag target
function onDocumentDragOver(evt) {
  evt.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf('Edge/') !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;

  return isIe(userAgent) || isEdge(userAgent);
}

var styles = {
  rejected: {
    borderStyle: 'solid',
    borderColor: '#c66',
    backgroundColor: '#eee'
  },
  disabled: {
    opacity: 0.5
  },
  active: {
    borderStyle: 'solid',
    borderColor: '#6c6',
    backgroundColor: '#eee'
  },
  default: {
    width: 200,
    height: 200,
    borderWidth: 2,
    borderColor: '#666',
    borderStyle: 'dashed',
    borderRadius: 5
  }
};

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Dropzone = function (_React$Component) {
  _inherits(Dropzone, _React$Component);

  function Dropzone(props, context) {
    _classCallCheck(this, Dropzone);

    var _this = _possibleConstructorReturn(this, (Dropzone.__proto__ || Object.getPrototypeOf(Dropzone)).call(this, props, context));

    _this.renderChildren = function (children, isDragActive, isDragAccept, isDragReject) {
      if (typeof children === 'function') {
        return children(_extends({}, _this.state, {
          isDragActive: isDragActive,
          isDragAccept: isDragAccept,
          isDragReject: isDragReject
        }));
      }
      return children;
    };

    _this.composeHandlers = _this.composeHandlers.bind(_this);
    _this.onClick = _this.onClick.bind(_this);
    _this.onDocumentDrop = _this.onDocumentDrop.bind(_this);
    _this.onDragEnter = _this.onDragEnter.bind(_this);
    _this.onDragLeave = _this.onDragLeave.bind(_this);
    _this.onDragOver = _this.onDragOver.bind(_this);
    _this.onDragStart = _this.onDragStart.bind(_this);
    _this.onDrop = _this.onDrop.bind(_this);
    _this.onFileDialogCancel = _this.onFileDialogCancel.bind(_this);
    _this.onInputElementClick = _this.onInputElementClick.bind(_this);

    _this.setRef = _this.setRef.bind(_this);
    _this.setRefs = _this.setRefs.bind(_this);

    _this.isFileDialogActive = false;

    _this.state = {
      draggedFiles: [],
      acceptedFiles: [],
      rejectedFiles: []
    };
    return _this;
  }

  _createClass(Dropzone, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var preventDropOnDocument = this.props.preventDropOnDocument;

      this.dragTargets = [];

      if (preventDropOnDocument) {
        document.addEventListener('dragover', onDocumentDragOver, false);
        document.addEventListener('drop', this.onDocumentDrop, false);
      }
      if (this.fileInputEl != null) {
        this.fileInputEl.addEventListener('click', this.onInputElementClick, false);
      }
      window.addEventListener('focus', this.onFileDialogCancel, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var preventDropOnDocument = this.props.preventDropOnDocument;

      if (preventDropOnDocument) {
        document.removeEventListener('dragover', onDocumentDragOver);
        document.removeEventListener('drop', this.onDocumentDrop);
      }
      if (this.fileInputEl != null) {
        this.fileInputEl.removeEventListener('click', this.onInputElementClick, false);
      }
      window.removeEventListener('focus', this.onFileDialogCancel, false);
    }
  }, {
    key: 'composeHandlers',
    value: function composeHandlers(handler) {
      if (this.props.disabled) {
        return null;
      }

      return handler;
    }
  }, {
    key: 'onDocumentDrop',
    value: function onDocumentDrop(evt) {
      if (this.node && this.node.contains(evt.target)) {
        // if we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
      }
      evt.preventDefault();
      this.dragTargets = [];
    }
  }, {
    key: 'onDragStart',
    value: function onDragStart(evt) {
      if (this.props.onDragStart) {
        this.props.onDragStart.call(this, evt);
      }
    }
  }, {
    key: 'onDragEnter',
    value: function onDragEnter(evt) {
      var _this2 = this;

      evt.preventDefault();

      // Count the dropzone and any children that are entered.
      if (this.dragTargets.indexOf(evt.target) === -1) {
        this.dragTargets.push(evt.target);
      }

      evt.persist();

      Promise.resolve(this.props.getDataTransferItems(evt)).then(function (draggedFiles) {
        _this2.setState({
          isDragActive: true, // Do not rely on files for the drag state. It doesn't work in Safari.
          draggedFiles: draggedFiles
        });
      });
      if (this.props.onDragEnter) {
        this.props.onDragEnter.call(this, evt);
      }
    }
  }, {
    key: 'onDragOver',
    value: function onDragOver(evt) {
      // eslint-disable-line class-methods-use-this
      evt.preventDefault();
      evt.stopPropagation();
      try {
        // The file dialog on Chrome allows users to drag files from the dialog onto
        // the dropzone, causing the browser the crash when the file dialog is closed.
        // A drop effect of 'none' prevents the file from being dropped
        evt.dataTransfer.dropEffect = this.isFileDialogActive ? 'none' : 'copy'; // eslint-disable-line no-param-reassign
      } catch (err) {
        // continue regardless of error
      }

      if (this.props.onDragOver) {
        this.props.onDragOver.call(this, evt);
      }
      return false;
    }
  }, {
    key: 'onDragLeave',
    value: function onDragLeave(evt) {
      var _this3 = this;

      evt.preventDefault();

      // Only deactivate once the dropzone and all children have been left.
      this.dragTargets = this.dragTargets.filter(function (el) {
        return el !== evt.target && _this3.node.contains(el);
      });
      if (this.dragTargets.length > 0) {
        return;
      }

      // Clear dragging files state
      this.setState({
        isDragActive: false,
        draggedFiles: []
      });

      if (this.props.onDragLeave) {
        this.props.onDragLeave.call(this, evt);
      }
    }
  }, {
    key: 'onDrop',
    value: function onDrop(evt) {
      var _this4 = this;

      var _props = this.props,
          onDrop = _props.onDrop,
          onDropAccepted = _props.onDropAccepted,
          onDropRejected = _props.onDropRejected,
          multiple = _props.multiple,
          disablePreview = _props.disablePreview,
          accept = _props.accept,
          getDataTransferItems = _props.getDataTransferItems;

      // Stop default browser behavior

      evt.preventDefault();

      // Persist event for later usage
      evt.persist();

      // Reset the counter along with the drag on a drop.
      this.dragTargets = [];
      this.isFileDialogActive = false;

      // Clear files value
      this.draggedFiles = null;

      // Reset drag state
      this.setState({
        isDragActive: false,
        draggedFiles: []
      });

      Promise.resolve(getDataTransferItems(evt)).then(function (fileList) {
        var acceptedFiles = [];
        var rejectedFiles = [];

        fileList.forEach(function (file) {
          if (!disablePreview) {
            try {
              file.preview = window.URL.createObjectURL(file); // eslint-disable-line no-param-reassign
            } catch (err) {
              if (process.env.NODE_ENV !== 'production') {
                console.error('Failed to generate preview for file', file, err); // eslint-disable-line no-console
              }
            }
          }

          if (fileAccepted(file, accept) && fileMatchSize(file, _this4.props.maxSize, _this4.props.minSize)) {
            acceptedFiles.push(file);
          } else {
            rejectedFiles.push(file);
          }
        });

        if (!multiple && acceptedFiles.length > 1) {
          // if not in multi mode add any extra accepted files to rejected.
          // This will allow end users to easily ignore a multi file drop in "single" mode.
          rejectedFiles.push.apply(rejectedFiles, _toConsumableArray(acceptedFiles.splice(0)));
        }

        if (onDrop) {
          onDrop.call(_this4, acceptedFiles, rejectedFiles, evt);
        }

        if (rejectedFiles.length > 0 && onDropRejected) {
          onDropRejected.call(_this4, rejectedFiles, evt);
        }

        if (acceptedFiles.length > 0 && onDropAccepted) {
          onDropAccepted.call(_this4, acceptedFiles, evt);
        }
      });
    }
  }, {
    key: 'onClick',
    value: function onClick(evt) {
      var _props2 = this.props,
          onClick = _props2.onClick,
          disableClick = _props2.disableClick;

      if (!disableClick) {
        evt.stopPropagation();

        if (onClick) {
          onClick.call(this, evt);
        }

        // in IE11/Edge the file-browser dialog is blocking, ensure this is behind setTimeout
        // this is so react can handle state changes in the onClick prop above above
        // see: https://github.com/react-dropzone/react-dropzone/issues/450
        if (isIeOrEdge()) {
          setTimeout(this.open.bind(this), 0);
        } else {
          this.open();
        }
      }
    }
  }, {
    key: 'onInputElementClick',
    value: function onInputElementClick(evt) {
      evt.stopPropagation();
      if (this.props.inputProps && this.props.inputProps.onClick) {
        this.props.inputProps.onClick();
      }
    }
  }, {
    key: 'onFileDialogCancel',
    value: function onFileDialogCancel() {
      var _this5 = this;

      // timeout will not recognize context of this method
      var onFileDialogCancel = this.props.onFileDialogCancel;
      // execute the timeout only if the FileDialog is opened in the browser

      if (this.isFileDialogActive) {
        setTimeout(function () {
          if (_this5.fileInputEl != null) {
            // Returns an object as FileList
            var files = _this5.fileInputEl.files;


            if (!files.length) {
              _this5.isFileDialogActive = false;
            }
          }

          if (typeof onFileDialogCancel === 'function') {
            onFileDialogCancel();
          }
        }, 300);
      }
    }
  }, {
    key: 'setRef',
    value: function setRef(ref) {
      this.node = ref;
    }
  }, {
    key: 'setRefs',
    value: function setRefs(ref) {
      this.fileInputEl = ref;
    }
    /**
     * Open system file upload dialog.
     *
     * @public
     */

  }, {
    key: 'open',
    value: function open() {
      this.isFileDialogActive = true;
      this.fileInputEl.value = null;
      this.fileInputEl.click();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          accept = _props3.accept,
          acceptClassName = _props3.acceptClassName,
          activeClassName = _props3.activeClassName,
          children = _props3.children,
          disabled = _props3.disabled,
          disabledClassName = _props3.disabledClassName,
          inputProps = _props3.inputProps,
          multiple = _props3.multiple,
          name = _props3.name,
          rejectClassName = _props3.rejectClassName,
          rest = _objectWithoutProperties(_props3, ['accept', 'acceptClassName', 'activeClassName', 'children', 'disabled', 'disabledClassName', 'inputProps', 'multiple', 'name', 'rejectClassName']);

      var acceptStyle = rest.acceptStyle,
          activeStyle = rest.activeStyle,
          _rest$className = rest.className,
          className = _rest$className === undefined ? '' : _rest$className,
          disabledStyle = rest.disabledStyle,
          rejectStyle = rest.rejectStyle,
          style = rest.style,
          props = _objectWithoutProperties(rest, ['acceptStyle', 'activeStyle', 'className', 'disabledStyle', 'rejectStyle', 'style']);

      var _state = this.state,
          isDragActive = _state.isDragActive,
          draggedFiles = _state.draggedFiles;

      var filesCount = draggedFiles.length;
      var isMultipleAllowed = multiple || filesCount <= 1;
      var isDragAccept = filesCount > 0 && allFilesAccepted(draggedFiles, this.props.accept);
      var isDragReject = filesCount > 0 && (!isDragAccept || !isMultipleAllowed);
      var noStyles = !className && !style && !activeStyle && !acceptStyle && !rejectStyle && !disabledStyle;

      if (isDragActive && activeClassName) {
        className += ' ' + activeClassName;
      }
      if (isDragAccept && acceptClassName) {
        className += ' ' + acceptClassName;
      }
      if (isDragReject && rejectClassName) {
        className += ' ' + rejectClassName;
      }
      if (disabled && disabledClassName) {
        className += ' ' + disabledClassName;
      }

      if (noStyles) {
        style = styles.default;
        activeStyle = styles.active;
        acceptStyle = styles.active;
        rejectStyle = styles.rejected;
        disabledStyle = styles.disabled;
      }

      var appliedStyle = _extends({ position: 'relative' }, style);
      if (activeStyle && isDragActive) {
        appliedStyle = _extends({}, appliedStyle, activeStyle);
      }
      if (acceptStyle && isDragAccept) {
        appliedStyle = _extends({}, appliedStyle, acceptStyle);
      }
      if (rejectStyle && isDragReject) {
        appliedStyle = _extends({}, appliedStyle, rejectStyle);
      }
      if (disabledStyle && disabled) {
        appliedStyle = _extends({}, appliedStyle, disabledStyle);
      }

      var inputAttributes = {
        accept: accept,
        disabled: disabled,
        type: 'file',
        style: _extends({
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          opacity: 0.00001,
          pointerEvents: 'none'
        }, inputProps.style),
        multiple: supportMultiple && multiple,
        ref: this.setRefs,
        onChange: this.onDrop,
        autoComplete: 'off'
      };

      if (name && name.length) {
        inputAttributes.name = name;
      }

      // Destructure custom props away from props used for the div element
      /* eslint-disable no-unused-vars */

      var divProps = _objectWithoutProperties(props, ['acceptedFiles', 'preventDropOnDocument', 'disablePreview', 'disableClick', 'onDropAccepted', 'onDropRejected', 'onFileDialogCancel', 'maxSize', 'minSize', 'getDataTransferItems']);
      /* eslint-enable no-unused-vars */

      /* eslint-disable jsx-a11y/no-static-element-interactions */
      /* eslint-disable jsx-a11y/click-events-have-key-events */


      return React__default.createElement(
        'div',
        _extends({
          className: className,
          style: appliedStyle
        }, divProps /* expand user provided props first so event handlers are never overridden */
        , {
          onClick: this.composeHandlers(this.onClick),
          onDragStart: this.composeHandlers(this.onDragStart),
          onDragEnter: this.composeHandlers(this.onDragEnter),
          onDragOver: this.composeHandlers(this.onDragOver),
          onDragLeave: this.composeHandlers(this.onDragLeave),
          onDrop: this.composeHandlers(this.onDrop),
          ref: this.setRef,
          'aria-disabled': disabled
        }),
        this.renderChildren(children, isDragActive, isDragAccept, isDragReject),
        React__default.createElement('input', _extends({}, inputProps /* expand user provided inputProps first so inputAttributes override them */
        , inputAttributes))
      );
    }
  }]);

  return Dropzone;
}(React__default.Component);

Dropzone.propTypes = {
  /**
   * Allow specific types of files. See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */
  accept: index$4.propTypes.oneOfType([index$4.propTypes.string, index$4.propTypes.arrayOf(index$4.propTypes.string)]),

  /**
   * Contents of the dropzone
   */
  children: index$4.propTypes.oneOfType([index$4.propTypes.node, index$4.propTypes.func]),

  /**
   * Disallow clicking on the dropzone container to open file dialog
   */
  disableClick: index$4.propTypes.bool,

  /**
   * Enable/disable the dropzone entirely
   */
  disabled: index$4.propTypes.bool,

  /**
   * Enable/disable preview generation
   */
  disablePreview: index$4.propTypes.bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: index$4.propTypes.bool,

  /**
   * Pass additional attributes to the `<input type="file"/>` tag
   */
  inputProps: index$4.propTypes.object,

  /**
   * Allow dropping multiple files
   */
  multiple: index$4.propTypes.bool,

  /**
   * `name` attribute for the input tag
   */
  name: index$4.propTypes.string,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: index$4.propTypes.number,

  /**
   * Minimum file size (in bytes)
   */
  minSize: index$4.propTypes.number,

  /**
   * className
   */
  className: index$4.propTypes.string,

  /**
   * className to apply when drag is active
   */
  activeClassName: index$4.propTypes.string,

  /**
   * className to apply when drop will be accepted
   */
  acceptClassName: index$4.propTypes.string,

  /**
   * className to apply when drop will be rejected
   */
  rejectClassName: index$4.propTypes.string,

  /**
   * className to apply when dropzone is disabled
   */
  disabledClassName: index$4.propTypes.string,

  /**
   * CSS styles to apply
   */
  style: index$4.propTypes.object,

  /**
   * CSS styles to apply when drag is active
   */
  activeStyle: index$4.propTypes.object,

  /**
   * CSS styles to apply when drop will be accepted
   */
  acceptStyle: index$4.propTypes.object,

  /**
   * CSS styles to apply when drop will be rejected
   */
  rejectStyle: index$4.propTypes.object,

  /**
   * CSS styles to apply when dropzone is disabled
   */
  disabledStyle: index$4.propTypes.object,

  /**
   * getDataTransferItems handler
   * @param {Event} event
   * @returns {Array} array of File objects
   */
  getDataTransferItems: index$4.propTypes.func,

  /**
   * onClick callback
   * @param {Event} event
   */
  onClick: index$4.propTypes.func,

  /**
   * onDrop callback
   */
  onDrop: index$4.propTypes.func,

  /**
   * onDropAccepted callback
   */
  onDropAccepted: index$4.propTypes.func,

  /**
   * onDropRejected callback
   */
  onDropRejected: index$4.propTypes.func,

  /**
   * onDragStart callback
   */
  onDragStart: index$4.propTypes.func,

  /**
   * onDragEnter callback
   */
  onDragEnter: index$4.propTypes.func,

  /**
   * onDragOver callback
   */
  onDragOver: index$4.propTypes.func,

  /**
   * onDragLeave callback
   */
  onDragLeave: index$4.propTypes.func,

  /**
   * Provide a callback on clicking the cancel button of the file dialog
   */
  onFileDialogCancel: index$4.propTypes.func
};

Dropzone.defaultProps = {
  preventDropOnDocument: true,
  disabled: false,
  disablePreview: false,
  disableClick: false,
  inputProps: {},
  multiple: true,
  maxSize: Infinity,
  minSize: 0,
  getDataTransferItems: getDataTransferItems
};

var StyledDropZone = styled__default(Dropzone)(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  width: 100%;\n  background-color: ", ";\n  cursor: ", ";\n  height: ", ";\n  padding: 0;\n"], ["\n  width: 100%;\n  background-color: ", ";\n  cursor: ", ";\n  height: ", ";\n  padding: 0;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.universal.white;
}, function (_a) {
    var croppedImageUrl = _a.croppedImageUrl;
    return (croppedImageUrl ? 'default' : 'pointer');
}, function (_a) {
    var dropzoneHeight = _a.dropzoneHeight;
    return dropzoneHeight;
});
var UploadButtonContainer = styled__default.div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  min-height: ", ";\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"], ["\n  min-height: ", ";\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"])), function (_a) {
    var dropzoneHeight = _a.dropzoneHeight;
    return dropzoneHeight;
});
var UploadButtonContainerText = styled__default.p(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  font-size: 14px;\n  line-height: 22px;\n  margin-top: 0;\n  text-align: center;\n"], ["\n  font-size: 14px;\n  line-height: 22px;\n  margin-top: 0;\n  text-align: center;\n"])));
var StyledAddIcon = styled__default(pictureAdd.PictureAdd)(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  width: 42px;\n  height: 42px;\n  color:  ", ";\n  margin-bottom: 4px;\n"], ["\n  width: 42px;\n  height: 42px;\n  color:  ", ";\n  margin-bottom: 4px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyDark;
});
var UploadButtonContent = styled__default.div(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n  text-align: center;\n"], ["\n  text-align: center;\n"])));
var DropZone = function (_a) {
    var className = _a.className, errorText = _a.errorText, dropzoneHeight = _a.dropzoneHeight, croppedImageUrl = _a.croppedImageUrl, onOpenFileDialog = _a.onOpenFileDialog, onDropZoneDrop = _a.onDropZoneDrop, getDropZoneRef = _a.getDropZoneRef, teaserText = _a.teaserText, uploadLabel = _a.uploadLabel, reuploadLabel = _a.reuploadLabel, icon = _a.icon, buttonProps = _a.buttonProps, restProps = tslib_es6.__rest(_a, ["className", "errorText", "dropzoneHeight", "croppedImageUrl", "onOpenFileDialog", "onDropZoneDrop", "getDropZoneRef", "teaserText", "uploadLabel", "reuploadLabel", "icon", "buttonProps"]);
    return (React__default.createElement(StyledDropZone, tslib_es6.__assign({ className: className + "-drop-zone", ref: getDropZoneRef, onDrop: onDropZoneDrop, "data-testid": "dropzone" }, restProps), !croppedImageUrl ? (React__default.createElement(UploadButtonContainer, { dropzoneHeight: dropzoneHeight },
        React__default.createElement(UploadButtonContent, null,
            icon || React__default.createElement(StyledAddIcon, null),
            React__default.createElement(UploadButtonContainerText, null, teaserText),
            React__default.createElement(button.Button, tslib_es6.__assign({ text: errorText ? reuploadLabel : uploadLabel, onClick: onOpenFileDialog }, buttonProps))))) : null));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

var ErrorContainer = styled__default.div(templateObject_1$1 || (templateObject_1$1 = tslib_es6.__makeTemplateObject(["\n  padding-left: 16px;\n  font-style: italic;\n  font-weight: normal;\n  font-size: 12px;\n  line-height: 22px;\n  margin-top: 4px;\n  display: flex;\n  flex-direction: row;\n  justify-content: start;\n  align-items: center;\n  font-family: ", ";\n  color: ", ";\n"], ["\n  padding-left: 16px;\n  font-style: italic;\n  font-weight: normal;\n  font-size: 12px;\n  line-height: 22px;\n  margin-top: 4px;\n  display: flex;\n  flex-direction: row;\n  justify-content: start;\n  align-items: center;\n  font-family: ", ";\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.admin.pink;
});
var TextContainer = styled__default.div(templateObject_2$1 || (templateObject_2$1 = tslib_es6.__makeTemplateObject(["\n  padding-left: 16px;\n  font-family: ", ";\n  color: ", ";\n  font-style: italic;\n  font-weight: normal;\n  font-size: 12px;\n  line-height: 22px;\n  margin-top: 4px;\n"], ["\n  padding-left: 16px;\n  font-family: ", ";\n  color: ", ";\n  font-style: italic;\n  font-weight: normal;\n  font-size: 12px;\n  line-height: 22px;\n  margin-top: 4px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyDark;
});
var Text = styled__default.span(templateObject_3$1 || (templateObject_3$1 = tslib_es6.__makeTemplateObject(["\n  color: ", ";\n  font-style: italic;\n  font-size: 12px;\n  line-height: 22px;\n  margin-top: 4px;\n  font-weight: bold;\n  padding-left: 0;\n"], ["\n  color: ", ";\n  font-style: italic;\n  font-size: 12px;\n  line-height: 22px;\n  margin-top: 4px;\n  font-weight: bold;\n  padding-left: 0;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyDark;
});
var StyledExclamationMark = styled__default(exclamationMark.ExclamationMark)(templateObject_4$1 || (templateObject_4$1 = tslib_es6.__makeTemplateObject(["\n  color: ", ";\n  font-size: 20px;\n  padding-right: 8px;\n"], ["\n  color: ", ";\n  font-size: 20px;\n  padding-right: 8px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.admin.pink;
});
var Footer = function (_a) {
    var errorText = _a.errorText, footerText = _a.footerText;
    var _b = tslib_es6.__read(footerText.split('replace'), 2), firstWord = _b[0], secondWord = _b[1];
    return (React__default.createElement(React__default.Fragment, null,
        errorText && (React__default.createElement(ErrorContainer, null,
            React__default.createElement(StyledExclamationMark, null),
            errorText)),
        !errorText && footerText && (React__default.createElement(TextContainer, null, footerText.includes('replace') ? (React__default.createElement(React__default.Fragment, null,
            firstWord,
            React__default.createElement(Text, null, "replace"),
            secondWord)) : footerText))));
};
var templateObject_1$1, templateObject_2$1, templateObject_3$1, templateObject_4$1;

var StyledImage = styled__default.img(templateObject_1$2 || (templateObject_1$2 = tslib_es6.__makeTemplateObject(["\n  visibility: hidden;\n  position: absolute;\n  opacity: 0;\n"], ["\n  visibility: hidden;\n  position: absolute;\n  opacity: 0;\n"])));
var FileName = styled__default(UploadButtonContainerText)(templateObject_2$2 || (templateObject_2$2 = tslib_es6.__makeTemplateObject(["\n  margin-bottom: 6px;\n  word-break: break-all;\n"], ["\n  margin-bottom: 6px;\n  word-break: break-all;\n"])));
var UploadButtonWrapper = styled__default.div(templateObject_3$2 || (templateObject_3$2 = tslib_es6.__makeTemplateObject(["\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: ", ";\n  transition: ", ";\n"], ["\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: ", ";\n  transition: ", ";\n"])), function (_a) {
    var errorText = _a.errorText, theme = _a.theme;
    return (errorText ? theme.colorsRgba.pink_1 : 'inherit');
}, function (_a) {
    var errorText = _a.errorText;
    return (errorText ? 'background-color ease 0.3s' : 'none');
});
var PreviewButtonContainer = styled__default.div(templateObject_4$2 || (templateObject_4$2 = tslib_es6.__makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  position: relative;\n  padding: 10px;\n  background-position: center;\n  background-image: ", ";\n  background-repeat: no-repeat;\n  background-size: cover;\n  max-width: 228px;\n  max-height: 146px;\n"], ["\n  width: 100%;\n  height: 100%;\n  position: relative;\n  padding: 10px;\n  background-position: center;\n  background-image: ", ";\n  background-repeat: no-repeat;\n  background-size: cover;\n  max-width: 228px;\n  max-height: 146px;\n"])), function (_a) {
    var previewBackgroundImage = _a.previewBackgroundImage;
    return ("url(" + previewBackgroundImage + ")");
});
var CloseIconContainer = styled__default.div(templateObject_5$1 || (templateObject_5$1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 24px;\n  width: 24px;\n  background-color: ", ";\n  border-radius: 50%;\n  cursor: pointer;\n  position: absolute;\n  top: -12px;\n  right: auto;\n  left: calc(100% - 12px);\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 24px;\n  width: 24px;\n  background-color: ", ";\n  border-radius: 50%;\n  cursor: pointer;\n  position: absolute;\n  top: -12px;\n  right: auto;\n  left: calc(100% - 12px);\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
});
var StyledCancelIcon = styled__default(close.Close)(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n  font-size: 24px;\n  color: ", ";\n"], ["\n  font-size: 24px;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.universal.white;
});
var ImagePreviewContainer = styled__default.div(templateObject_7 || (templateObject_7 = tslib_es6.__makeTemplateObject(["\n  max-width: 100%;\n  max-height: 100%;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  background-image: ", ";\n"], ["\n  max-width: 100%;\n  max-height: 100%;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  background-image: ", ";\n"])), function (_a) {
    var croppedImageUrl = _a.croppedImageUrl;
    return (croppedImageUrl ? "url(" + croppedImageUrl + ")" : 'none');
});
var StyledButton = styled__default(button.Button)(templateObject_8 || (templateObject_8 = tslib_es6.__makeTemplateObject(["\n  margin-top: 10px;\n"], ["\n  margin-top: 10px;\n"])));
var ImagePreview = function (_a) {
    var className = _a.className, errorText = _a.errorText, imagePreviewUrl = _a.imagePreviewUrl, croppedImageUrl = _a.croppedImageUrl, onOpenFileDialog = _a.onOpenFileDialog, onCancelClick = _a.onCancelClick, previewBackgroundImage = _a.previewBackgroundImage, uploadLabel = _a.uploadLabel, reuploadLabel = _a.reuploadLabel, getImageRef = _a.getImageRef, buttonProps = _a.buttonProps, icon = _a.icon, fileName = _a.fileName;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(StyledImage, { alt: "", src: imagePreviewUrl, ref: getImageRef }),
        croppedImageUrl !== '' && (React__default.createElement(UploadButtonWrapper, { className: className + "-file-preview", errorText: errorText },
            React__default.createElement(PreviewButtonContainer, { previewBackgroundImage: previewBackgroundImage },
                React__default.createElement(CloseIconContainer, { onClick: onCancelClick, className: className + "-fp-close" },
                    React__default.createElement(StyledCancelIcon, { variant: "adminGreyDark", size: "xs" })),
                icon,
                React__default.createElement(ImagePreviewContainer, { croppedImageUrl: croppedImageUrl, className: className + "-fp-image" })),
            React__default.createElement(React__default.Fragment, null,
                fileName && React__default.createElement(FileName, null, fileName),
                React__default.createElement(StyledButton, tslib_es6.__assign({ text: errorText ? reuploadLabel : uploadLabel, onClick: onOpenFileDialog }, buttonProps)))))));
};
var templateObject_1$2, templateObject_2$2, templateObject_3$2, templateObject_4$2, templateObject_5$1, templateObject_6, templateObject_7, templateObject_8;

exports.DropZone = DropZone;
exports.Footer = Footer;
exports.ImagePreview = ImagePreview;
